export default function datocmsImageLoader({ src, width, quality }: any) {
  // Remove any existing query parameters from the src URL
  const baseSrcUrl = src.split('?')[0];
  return `${baseSrcUrl}?auto=format&w=${width}&q=${quality || 75}`;
}
